class CartNotification extends HTMLElement {
  constructor() {
    super();

    this.notification = document.getElementById("cart-notification");

    if (!this.notification) {
      return;
    }

    this.onBodyClick = this.handleBodyClick.bind(this);

    this.notification.addEventListener("keyup", (evt) => {
      if (evt.code === "Escape") this.close();
    });

    this.querySelectorAll('button[type="button"]').forEach((closeButton) =>
      closeButton.addEventListener("click", this.close.bind(this))
    );

    document.addEventListener("cart:updated", (event) => {
      this.renderContents(event.detail);
    });
  }

  open() {
    if (!this.notification) return;
    this.notification.classList.add("animate", "active");
    document.querySelector("cart-notification").classList.add("active");

    this.notification.addEventListener(
      "transitionend",
      () => {
        this.notification.focus();
        trapFocus(this.notification);
      },
      { once: true }
    );

    document.body.addEventListener("click", this.onBodyClick);
  }

  close() {
    if (!this.notification) return;
    this.notification.classList.remove("active");
    document.querySelector("cart-notification").classList.remove("active");
    document.body.removeEventListener("click", this.onBodyClick);
    removeTrapFocus(this.activeElement);
  }

  renderContents(parsedState) {
    if (!parsedState || !this.notification) return;

    this.cartItemKey = parsedState.key;
    this.getSectionsToRender().forEach((section) => {
      const sectionEl = document.getElementById(section.id);
      if (sectionEl && parsedState.sections[section.id]) {
        sectionEl.innerHTML = this.getSectionInnerHTML(
          parsedState.sections[section.id],
          section.selector
        );
      }
    });

    this.open();
  }

  getSectionsToRender() {
    return [
      {
        id: "cart-notification-product",
        selector: `[id="cart-notification-product-${this.cartItemKey}"]`,
      },
      { id: "cart-notification-button" },
      { id: "cart-icon-bubble" },
    ];
  }

  getSectionInnerHTML(html, selector = ".shopify-section") {
    const parsedHTML = new DOMParser().parseFromString(html, "text/html");
    return parsedHTML.querySelector(selector)?.innerHTML || "";
  }

  handleBodyClick(evt) {
    if (!this.notification) return;

    const target = evt.target;
    if (target !== this.notification && !target.closest("cart-notification")) {
      const disclosure = target.closest("details-disclosure, header-menu");
      this.activeElement = disclosure
        ? disclosure.querySelector("summary")
        : null;
      this.close();
    }
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define("cart-notification", CartNotification);

// Ensure the cart notification updates when a product is added
document.addEventListener("cart:updated", (event) => {
  const cartNotification = document.querySelector("cart-notification");
  if (cartNotification) {
    cartNotification.renderContents(event.detail);
  }
});

// Shopify's default add-to-cart AJAX function should trigger this event
document.addEventListener("DOMContentLoaded", () => {
  document.querySelectorAll('form[action*="/cart/add"]').forEach((form) => {
    form.addEventListener("submit", (event) => {
      event.preventDefault();

      fetch(event.target.action, {
        method: "POST",
        body: new FormData(event.target),
      })
        .then((res) => res.json())
        .then((data) => {
          document.dispatchEvent(
            new CustomEvent("cart:updated", { detail: data })
          );
        });
      // .catch((err) => console.error('Error adding to cart:', err));
    });
  });

  document.querySelectorAll('form[action*="/cart/add"]').forEach((form) => {
    form.addEventListener("submit", (event) => {
      event.preventDefault();

      fetch(event.target.action, {
        method: "POST",
        body: new FormData(event.target),
        headers: {
          Accept: "application/json",
        },
      })
        .then((res) => res.json())
        .then((data) => {
          console.log("Product added to cart:", data);

          // Manually update the cart count
          updateCartCount();

          // Trigger cart notification
          document.dispatchEvent(
            new CustomEvent("cart:updated", { detail: data })
          );
        })
        .catch((err) => console.error("Error adding to cart:", err));
    });
  });

  // Function to update cart count dynamically
  function updateCartCount() {
    fetch("/cart.js")
      .then((res) => res.json())
      .then((cart) => {
        console.log("Updated cart data:", cart);
        const cartCountBubble = document.querySelector(".cart-count-bubble");

        if (cart.item_count > 0) {
          if (!cartCountBubble) {
            // If bubble does not exist, create it
            const newBubble = document.createElement("div");
            newBubble.className = "cart-count-bubble";
            newBubble.innerHTML = `
              <span aria-hidden="true">${cart.item_count}</span>
              <span class="visually-hidden">${cart.item_count} items in cart</span>
            `;
            document.querySelector(".cart").appendChild(newBubble);
          } else {
            // Update existing cart count
            cartCountBubble.querySelector(
              "span[aria-hidden='true']"
            ).textContent = cart.item_count;
          }
        } else {
          if (cartCountBubble) cartCountBubble.remove();
        }
      })
      .catch((err) => console.error("Error updating cart count:", err));
  }
});
